import type { Subscription } from "../../schemas/subscriptionSchema";
import { ConfirmationModal } from "../../components/Modal/ConfirmationModal";

type CancelConfirmationModalProps = {
  subscriptions: Subscription[];
  onClose: () => void;
  onConfirm: () => Promise<void>;
};

export function CancelConfirmationModal({
  subscriptions,
  onClose,
  onConfirm,
}: CancelConfirmationModalProps) {
  const totalItems = subscriptions.length;

  const affectedItems = subscriptions.map(subscription => ({
    id: subscription.id,
    name: subscription.companyName || String(subscription.firmId),
    code: subscription.package?.productCode,
  }));

  return (
    <ConfirmationModal
      title={`Cancel Subscription${totalItems > 1 ? "s" : ""}`}
      message={`Are you sure you want to cancel ${totalItems > 1 ? "these" : "this"} subscription${totalItems > 1 ? "s" : ""}?`}
      warningMessage="This will set the subscription status to 'cancelled'. If needed, the subscription can be reactivated later."
      affectedItems={affectedItems}
      confirmButtonText={`Cancel ${totalItems} Subscription${totalItems > 1 ? "s" : ""}`}
      confirmButtonColor="error"
      cancelButtonText="Keep Subscription"
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
}
